module.exports = __webpack_public_path__ + "static/media/34.429d1170.jpeg";